import './styles.scss';
import Moment from 'react-moment';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FileCopy } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import l from '../../../../lang';
import ChipStatus from '../../../common/chip-status';
import { Urls } from '../../../../config/urls';
import { createDate } from '../../../../utils';

interface TransactionDetailProps {
  detail: { [key: string]: string };
}

const TransactionDetail = ({ detail }: TransactionDetailProps) => {
  return (
    <div className="transaction-detail">
      <div className="transaction-detail__label-status">
        <ChipStatus status={detail.status} text={l(`transactions.status.${detail.status}`)} />
      </div>

      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.date')}</div>
          <Moment format="DD/MM/YYYY">{createDate(detail.creationDate)}</Moment>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.time')}</div>
          <Moment format="hh:mm:ss a">{createDate(detail.creationDate)}</Moment>
        </div>
      </div>
      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.country')}</div>
          <div className="transaction-detail__country">
            <img
              alt=""
              className="transaction-detail__country__flag"
              src={`${Urls.flags.replace(':code', detail.country)}`}
            />
            <span>&nbsp;{l(`countryCode.${detail.country}`)}</span>
          </div>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.invoiceId')}</div>
          <div>{detail.invoiceId}</div>
        </div>
      </div>
      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.totalAmount')}</div>
          <div>
            {detail.currency} {detail.localAmount}
          </div>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.balanceAmount')}</div>
          <div>
            {detail.balanceCurrency} {detail.balanceAmount}
          </div>
        </div>
      </div>
      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.balanceFee')}</div>
          <div>
            {detail.balanceCurrency} {detail.balanceFee}
          </div>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.description')}</div>
          <div>{detail.description || '-'}</div>
        </div>
      </div>
      <div>
        <div className="transaction-detail__item transaction-detail__item--full">
          <div className="transaction-detail__subtitle">{l('transactions.externalId')}</div>
          <div className="transaction-detail__external-id">
            {detail.externalId ? (
              <span>
                <span>{detail.externalId}</span>
                <CopyToClipboard text={detail.externalId}>
                  <IconButton>
                    <FileCopy fontSize="small" />
                  </IconButton>
                </CopyToClipboard>
              </span>
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </div>
      <div className="transaction-detail__separator" />
      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.clientName')}</div>
          <div>
            {detail.clientFirstName} {detail.clientLastName}
          </div>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.clientDocument')}</div>
          <div>
            {detail.clientDocumentType} {detail.clientDocument}
          </div>
        </div>
      </div>
      <div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.clientId')}</div>
          <div>{detail.clientId}</div>
        </div>
        <div className="transaction-detail__item">
          <div className="transaction-detail__subtitle">{l('transactions.clientEmail')}</div>
          <div>{detail.clientEmail}</div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetail;
